import { TextLarge, Title } from "@finanedi.es/front/common/atoms"
import { TInfo } from "@finanedi.es/front/common/templates"

export const TLeyAntifraudeFormModalTitle = () => {
  return (
    <div className='fs-flex fs-flex-col fs-gap-2 fs-px-1 1k:fs-px-2'>
      <div className='fs-flex fs-items-center'>
        <Title text='Configuración Verifactu' />
        <div className='fs-text-sm'>
          <TInfo text='Completa los datos del/los representante/s, descargue el documento de Verifactu y súbalo firmado digitalmente.' />
        </div>
      </div>
      <TextLarge
        className='fs-text-sm'
        text='Selecciona una de las dos opciones:'
      />
    </div>
  )
}
